module.exports = __webpack_public_path__ + "fonts/Inter-ExtraBoldItalic.f11ccd6.woff2";